<ui-list-view
    [listItems]="(mapItems$ | async) ?? fallbackMapItems"
    [itemContentComponentType]="popupContentComponentType"
    (reloadListData)="reloadMapData()"
>
    <ui-filter-mapper filters/>
</ui-list-view>
